var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHangup = function SvgHangup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hangup_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.003 40.006c11.047 0 20.003-8.956 20.003-20.003S31.05 0 20.003 0 0 8.956 0 20.003s8.956 20.003 20.003 20.003Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.68 24.403a11.462 11.462 0 0 1 2.981-2.099 1.55 1.55 0 0 0 .9-1.33l.448-2.837a12.76 12.76 0 0 1 8.043.137l.393 2.778a1.61 1.61 0 0 0 .84 1.443 11.524 11.524 0 0 1 2.94 2.2 1.592 1.592 0 0 0 2.248.036l2.67-2.582a1.591 1.591 0 0 0 .036-2.253 18.602 18.602 0 0 0-26.233-.448 1.592 1.592 0 0 0-.036 2.254l2.576 2.665a1.592 1.592 0 0 0 2.248.042l-.054-.006Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hangup_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgHangup;